/* eslint-disable jsx-a11y/accessible-emoji */
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PersonMonocularIcon from './images/person-monocular-icon';

const MaintenancePage = () => (
  <Container fluid className="error-404-container">
    <Row className="justify-content-center">
      <Col xs={8}>
        <div className="content">
          <PersonMonocularIcon />
          <h3 className="content-header semibold-6 gray-txt-10">
            LeadFinder is Temporarily Unavailable
          </h3>
          <div className="regular-2 gray-txt-9">
            ⚠️ We’re facing a temporary issue with lead search! Some searches
            and reveals may not work right now. We’re on it and it should be
            resolved shortly.
          </div>
          <div className="regular-2 gray-txt-9">
            Please check back shortly — we appreciate your understanding.
          </div>
        </div>
      </Col>
    </Row>
  </Container>
);

export default MaintenancePage;
